/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved, import/extensions */
import { createPerimeter } from 'vue-kindergarten';
/* eslint-enable */

export default createPerimeter({
  purpose: 'administration',

  can: {
    // page access guarded by auth-routes.  these rules set up the perimeter for page level access rights
    editAll() {
      return this.isSuper || (this.isOci() && this.isOciAdmin());
    },

    viewAdminPages() {
      return true;
    },

    editAdminPages() {
      return this.isAllowed('viewAdminPages')
    },

    // Dashboard Menu Items
    viewAdminDashboard(){
      return this.isSuper() || (this.isOci() && this.isOciAdmin())
    },
  },

  isSuper() {
    return this.child.isSuper;
  },

  isOciAdmin() {
    return this.child.isOciAdmin;
  },

  isOci() {
    return this.child.isOci;
  },
  isOciGroup() {
    return this.child.isOciGroup;
  },
  isLenderGroup() {
    return this.child.isLenderGroup;
  },
  isSuperGroup() {
    return this.child.isSuperGroup;
  },
  isDeveloperGroup() {
    return this.child.isDeveloperGroup;
  },
  isPartnerGroup() {
    return this.child.isPartnerGroup;
  },
});
